<div class="add-70">
    <div class="full-banner">
        <div class="container align-items-center flex-wrap h-100" style="display: grid;">
            <h2 class="font-600 text-center">
                From a Thousand to the One that Lasts
            </h2>
        </div>
        <div class="down-arrow">
            <img src="assets/img/drop_down.svg" alt="">
        </div>
    </div>
</div>

<div class="page-section">
    <div class="container">
        <div class="row" [@openClose]>
            <div class="col-12 text-center">
                <h3 class="font-600">What's your <span class="purple">Setup?</span></h3>
            </div>
            <div class="col-12 selection-row text-center">
                <ng-container *ngFor="let slug of setups">
                    <span [ngClass]="slug.is_active ? 'clicked-slug' : 'clickable-slug'" (click)="selectLevel1(slug)">{{slug.label}}</span>
                </ng-container>
            </div>

        </div>

        <div class="row mt-3" [@openClose] *ngIf="selected_setup && selected_setup.id && (selected_setup.id == 1 || selected_setup.id == 6)">
            <div class="col-12 text-center">
                <h3 class="font-600">Great, how many <span class="purple">Beds?</span></h3>
            </div>

            <div class="col-12 selection-row text-center">
                <ng-container *ngFor="let slug of beds">
                    <ng-container *ngIf="checkForLevelParent(slug, selected_setup)">
                        <span [ngClass]="slug.is_active ? 'clicked-slug' : 'clickable-slug'" (click)="selectLevel2(slug)">{{slug.label}}</span>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <div class="row mt-3" [@openClose] *ngIf="(selected_bed && selected_bed.id) || (selected_setup && selected_setup.id && selected_setup.id == 5)">
            <div class="col-12 text-center">
                <h3 class="font-600">What <span class="purple">Departments</span> do you have?</h3>
            </div>

            <div class="col-12 selection-row text-center">
                <ng-container *ngFor="let slug of departments">
                    <ng-container *ngIf="checkForLevelParent(slug, selected_bed)">
                        <span [ngClass]="slug.is_active ? 'clicked-slug' : 'clickable-slug'" (click)="selectLevel3(slug)">{{slug.label}}</span>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <ng-container *ngIf="checkCardsShow()">
            <div class="text-center mb-3">
                <button class="button btn brand-button" (click)="viewRecommendations()">
                    <ng-container *ngIf="!_view_recommendations; else update">
                        View Recommendations
                    </ng-container>
                    <ng-template #update>
                        Update Recommendations
                    </ng-template>

                </button>
            </div>
        </ng-container>
        
        <div class="row" *ngIf="!(selected_department && selected_department.length)">
            <div class="col-12 text-center">
                <a routerLink="/product/list" class="subtle">Click here to view all products.</a>
            </div>
        </div>
    </div>

    <ng-container *ngIf="_view_recommendations">
        <div class="container mt-5">
            <div class="row">
                <div class="col text-center">
                    <h3 class="font-600">Here Are Some of Our <span class="purple">Recommendations</span></h3>
                </div>
            </div>
            <div class="row mt-3">
                <ng-container *ngFor="let card of recommended_product_cards">
                    <!-- <ng-container *ngIf="checkCard(card)"> -->
                        <div class="col-lg-3 col-md-6 col-12 smooth">
                            <div class="card border-mint product-card">
                                <div class="card-body text-center">
                                    <div class="card-top">
                                        <img [src]="card.link" [alt]="card.name">
                                        <div class="card-name">
                                            <h5>{{card.name}}</h5>
                                        </div>
                                    </div>
                                    <div class="card-bottom">
                                        <ng-container *ngFor="let desc of card.description; let i = index">
                                            <span class="card-description">{{desc}}</span>
                                            <ng-container *ngIf="i < card.description.length - 1">
                                                •
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- </ng-container> -->
                </ng-container>
            </div>
            <div class="row mt-5">
                <div class="col-12 text-center">
                    <h4>Want to See More?</h4>
                </div>
    
                <div class="col-12 text-center">

                    <button type="button" class="btn button brand-button mt-2" (click)="storeChoices()">See All Products</button>
                </div>
            </div>
        </div>

    </ng-container>
</div>

<app-send-info-banner></app-send-info-banner>
<app-send-updates></app-send-updates>